import AboutUsHeroSection from './AboutUsHero'
import AccessSection from './Access'
import AccessTopCoursesSection from './AccessTopCourses'
import BlogPostHeroSection from './BlogPostHero'
import BookMeetingSection from './BookMeeting'
import BusinessIndividualSection from './BusinessIndividual'
import ClubhouseHeroSection from './ClubhouseHero'
import ContactUsSection from './ContactUs'
import EmajinCorporateMembershipPackagesSection from './EmajinCorporateMembershipPackages'
import EmajinMembershipsSection from './EmajinMemberships'
import EventDetailsDescriptionSection from './EventDetailsDescription'
import EventDetailsHeroSection from './EventDetailsHero'
import EventsHeroSection from './EventsHero'
import EventsListSection from './EventsList'
import ExecutiveInviteHeroSection from './ExecutiveInviteHero'
import ExecutiveInviteHowItWorksSection from './ExecutiveInviteHowItWorks'
import ExecutiveInviteQuestionSection from './ExecutiveInviteQuestion'
import ExecutiveInviteWelcomeSection from './ExecutiveInviteWelcome'
import ExploreCorporateMembershipSection from './ExploreCorporateMembership'
import ExploreIndividualMembershipSection from './ExploreIndividualMembership'
import ExploreOurMembershipsSection from './ExploreOurMemberships'
import FAQSection from './FAQ'
import GetAppSection from './GetApp'
import GrowSection from './Grow'
import GrowYourNetworkSection from './GrowYourNetwork'
import HomeHeroSection from './HomeHero'
import HowItWorksSection from './HowItWorks'
import LatestEventsSection from './LatestEvents'
import LatestNewsSection from './LatestNews'
import LearnSection from './Learn'
import LearnFromTopVoicesSection from './LearnFromTopVoices'
import MeetOutMembersSection from './MeetOutMembers'
import MembershipPointsSection from './MembershipPoints'
import MembershipsCorporateHeroSection from './MembershipsCorporateHero'
import MembershipsHeroSection from './MembershipsHero'
import MembershipsIndividualHeroSection from './MembershipsIndividualHero'
import MoreThanJustGolfSection from './MoreThanJustGolf'
import NewsBoardSection from './NewsBoard'
import OurPartnersSection from './OurPartners'
import OurPlatinumMembersSection from './OurPlatinumMembers'
import RelatedBlogsSection from './RelatedBlogs'
import SubmitScoreboardFormSection from './SubmitScoreboardForm'
import TeamMembersSection from './TeamMembers'
import TeeOffCorporateMembershipPackagesSection from './TeeOffCorporateMembershipPackages'
import TestimonialsSection from './Testimonials'
import ThankYouHeroSection from './ThankYouHero'
import ThankYouInfoSection from './ThankYouInfo'
import ThankYouLinksSection from './ThankYouLinks'
import WelcomeSection from './Welcome'
import WhoIsEmajinForSection from './WhoIsEmajinFor'
import WhyChooseEmajinGolfSection from './WhyChooseEmajinGolf'
import WhyDoYouNeedActNowSection from './WhyDoYouNeedActNow'

export {
  AboutUsHeroSection,
  AccessSection,
  AccessTopCoursesSection,
  BlogPostHeroSection,
  BookMeetingSection,
  BusinessIndividualSection,
  ClubhouseHeroSection,
  ContactUsSection,
  EmajinCorporateMembershipPackagesSection,
  EmajinMembershipsSection,
  EventDetailsDescriptionSection,
  EventDetailsHeroSection,
  EventsHeroSection,
  EventsListSection,
  ExecutiveInviteHeroSection,
  ExecutiveInviteHowItWorksSection,
  ExecutiveInviteQuestionSection,
  ExecutiveInviteWelcomeSection,
  ExploreCorporateMembershipSection,
  ExploreIndividualMembershipSection,
  ExploreOurMembershipsSection,
  FAQSection,
  GetAppSection,
  GrowSection,
  GrowYourNetworkSection,
  HomeHeroSection,
  HowItWorksSection,
  LatestEventsSection,
  LatestNewsSection,
  LearnFromTopVoicesSection,
  LearnSection,
  MeetOutMembersSection,
  MembershipPointsSection,
  MembershipsCorporateHeroSection,
  MembershipsHeroSection,
  MembershipsIndividualHeroSection,
  MoreThanJustGolfSection,
  NewsBoardSection,
  OurPartnersSection,
  OurPlatinumMembersSection,
  RelatedBlogsSection,
  SubmitScoreboardFormSection,
  TeamMembersSection,
  TeeOffCorporateMembershipPackagesSection,
  TestimonialsSection,
  ThankYouHeroSection,
  ThankYouInfoSection,
  ThankYouLinksSection,
  WelcomeSection,
  WhoIsEmajinForSection,
  WhyChooseEmajinGolfSection,
  WhyDoYouNeedActNowSection,
}
